import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-posh-n-sip';

export default function Example() {
  return (
    <>
      <Head>
        <title>Posh N' Sip: A Party for Poshmark Sellers</title>
        <meta
          name='description'
          content='Learn about opportunities to get together with other sellers and enjoy the company of others in the same reseller mindset!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-posh-n-sip' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-posh-n-sip' />
        <meta property='og:title' content="Posh N' Sip: A Party for Poshmark Sellers" />
        <meta
          property='og:description'
          content='Learn about opportunities to get together with other sellers and enjoy the company of others in the same reseller mindset!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
